import React, { useEffect, useState } from 'react'
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import useBreadcrumbs from "use-react-router-breadcrumbs";
// import srcSeries from '../Data/series.json'
import { Link } from 'react-router-dom';

export default function Breadcrumbs(props) {
    const breadcrumbs = useBreadcrumbs(props.routes);
    const [srcSeries, setSrcSeries] = useState(props.series)
    const [series, setSeries] = useState({name:''})
    const [video, setVideo] = useState({name:''})
    const [file, setFile] = useState({name:''})

    useEffect(() => {
        const currentPage = breadcrumbs[breadcrumbs.length - 1]
        if (currentPage.location.search.includes('?sid')) {
            // We're in a series
            setSeries(srcSeries.find((s) => s.uuid === currentPage.location.search.replace('?sid=','')))
        } else if (currentPage.location.search.includes('?vid')) {
            // We're in a video
            setSeries(srcSeries.find((s) => s.modules && s.modules.find((m) => m.uuid === currentPage.location.search.replace('?vid=',''))))
            setVideo(srcSeries.find((s) => s.modules && s.modules.find((m) => m.uuid === currentPage.location.search.replace('?vid=',''))).modules.find((m) => m.uuid === currentPage.location.search.replace('?vid=','')))
        } else if (currentPage.location.search.includes('?fid')) {
            // We're in a file
            setSeries(srcSeries.find((s) => s.files && s.files.find((f) => f.uuid === currentPage.location.search.replace('?fid=',''))))
            setFile(srcSeries.find((s) => s.files && s.files.find((f) => f.uuid === currentPage.location.search.replace('?fid=',''))).files.find((f) => f.uuid === currentPage.location.search.replace('?fid=','')))
        }
    },[breadcrumbs, srcSeries])
    
    return (
        <Row style={{position:'sticky',top:'0',zIndex:'100',background:'white',height:'4rem',borderBottom:'1px solid lightgray',display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',fontSize:'1rem'}}>         
            <Breadcrumb style={{paddingLeft:'1rem'}}>
                {breadcrumbs.map(({match, location, breadcrumb}, idx ) => {
                    let bc = breadcrumb
                    let search = props.user ? '?uid=' + props.user.token : ''

                    if(match.pathname === '/series') { 
                        bc = <span>{series.name}</span>
                        search = '?sid=' + series.uuid
                    }
                    if(match.pathname === '/series/video') {
                         bc = <span>{video.name}</span>
                         search = '?vid=' + video.uuid
                    }
                    if(match.pathname === '/series/file') {
                         bc = <span>{file.name}</span>
                         search = '?fid=' + file.uuid
                    }

                    return (
                        <Breadcrumb.Item key={idx} linkAs={Link} linkProps={{ to: match.pathname + search }} target='_self'>
                            {bc}
                        </Breadcrumb.Item>
                    )
                })}
            </Breadcrumb>
        </Row>
    );
}